import React, { useEffect, useState } from 'react';
const headlines = ['„Veränderungsbereitschaft und -fähigkeit festzustellen, ist ein Erfolgsfaktor in Veränderungsprozessen."', '„Diagnostik ist die Grundlage für zielsichere Entscheidungen und passgenaue Entwicklung."', '„Mit einer maßgeschneiderten Diagnostik lassen sich Schlüsselpositionen sicher besetzen."'];
interface FlipCardProps {
  frontTitle: string;
  backTitle: string;
  link: string;
}
const FlipCard: React.FC<FlipCardProps> = ({
  frontTitle,
  backTitle,
  link
}) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const handleClick = () => {
    window.location.href = link;
  };
  return <div className="relative w-full aspect-square cursor-pointer" style={{
    perspective: '1000px'
  }} onMouseEnter={() => setIsFlipped(true)} onMouseLeave={() => setIsFlipped(false)} onClick={handleClick} data-id="element-489">
      <div className="relative w-full h-full transition-transform duration-700" style={{
      transformStyle: 'preserve-3d',
      transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'
    }} data-id="element-490">
        {/* Front */}
        <div className="absolute w-full h-full bg-white flex flex-col items-center justify-center p-8" style={{
        backfaceVisibility: 'hidden',
        WebkitBackfaceVisibility: 'hidden'
      }} data-id="element-491">
          <div className="mb-4" data-id="element-492">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-700" data-id="element-493">
              <polyline points="18 15 12 9 6 15" data-id="element-494"></polyline>
            </svg>
          </div>
          <h3 className="text-xl text-orange-500 text-center font-normal" data-id="element-495">
            {frontTitle}
          </h3>
        </div>

        {/* Back */}
        <div className="absolute w-full h-full bg-white flex items-center justify-center p-8" style={{
        backfaceVisibility: 'hidden',
        WebkitBackfaceVisibility: 'hidden',
        transform: 'rotateY(180deg)'
      }} data-id="element-496">
          <h3 className="text-xl text-orange-500 text-center font-normal" data-id="element-497">
            {backTitle}
          </h3>
        </div>
      </div>
    </div>;
};
export const ManagementDiagnostikPage: React.FC = () => {
  const [currentHeadline, setCurrentHeadline] = useState(0);
  const [fadeState, setFadeState] = useState<'visible' | 'fading'>('visible');
  useEffect(() => {
    const interval = setInterval(() => {
      setFadeState('fading');
      setTimeout(() => {
        setCurrentHeadline(prev => (prev + 1) % headlines.length);
        setFadeState('visible');
      }, 500);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <>
      <section className="w-full bg-white py-16 px-6 md:px-12 lg:px-20" data-id="element-498">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-499">
          <div data-id="element-500">
            <h1 className="text-3xl md:text-4xl text-orange-500 font-light mb-6 transition-opacity duration-500" style={{
            opacity: fadeState === 'visible' ? 1 : 0,
            minHeight: '160px'
          }} data-id="element-501">
              {headlines[currentHeadline]}
            </h1>
          </div>
          <div className="flex justify-center" data-id="element-502">
            <img src="https://cdn.magicpatterns.com/uploads/kRWayT8V2CYMAcAFFN6CDB/Eva-Schifferer-Management_Diagnostik.png" alt="Management Diagnostik Puzzle" className="max-h-80 object-contain" data-id="element-503" />
          </div>
        </div>
      </section>

      <section className="w-full text-white py-16 px-6 md:px-12 lg:px-20" style={{
      backgroundColor: '#545454'
    }} data-id="element-504">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-505">
          <div data-id="element-506">
            <p className="mb-6 text-base leading-relaxed" data-id="element-507">
              Einer fundierten Diagnostik und Aussagen über Persönlichkeit und
              Potenzial kommt gerade in Veränderungsprozessen eine
              Schlüsselfunktion zu, um eine Passung zwischen Person, Aufgabe und
              Kultur sowie der Veränderungsfähigkeit festzustellen. So können
              Sie frühzeitig die Weichen auf Erfolg stellen und kostenintensive
              Fehlbesetzungen oder Abgänge vermeiden.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-508">
              Ob bei Eintritt in ein Unternehmen, beim Wechsel auf eine Position
              mit umfassender Verantwortung oder mit Blick auf ein ganzes
              Führungsteam – ein professioneller Blick auf Potenzial und
              Persönlichkeit von Führungskräften ist Grundlage für zielsichere
              Entscheidungen.
            </p>
          </div>
          <div data-id="element-509">
            <p className="mb-6 text-base leading-relaxed font-semibold" data-id="element-510">
              Das Verständnis von Diagnostik:
            </p>
            <ul className="mb-6 space-y-3 text-base leading-relaxed" data-id="element-511">
              <li className="flex items-start" data-id="element-512">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-513"></span>
                <span data-id="element-514">wissenschaftlich fundiert vorgehen</span>
              </li>
              <li className="flex items-start" data-id="element-515">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-516"></span>
                <span data-id="element-517">den Mensch in den Mittelpunkt stellen</span>
              </li>
              <li className="flex items-start" data-id="element-518">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-519"></span>
                <span data-id="element-520">trennscharf die erfolgskritischen Faktoren abbilden</span>
              </li>
              <li className="flex items-start" data-id="element-521">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-522"></span>
                <span data-id="element-523">
                  psychometrische Testverfahren wie Persönlichkeitstests und
                  Leistungstests einsetzen, wenn es sinnvoll ist
                </span>
              </li>
            </ul>
            <p className="mb-6 text-base leading-relaxed" data-id="element-524">
              Wir erarbeiten maßgeschneiderte Lösungen für Ihre Fragestellung
              und setzen diese Sie mit Ihnen in deutscher und englischer Sprache
              um.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-525">
              Bei diagnostischen Themen arbeite ich eng mit einem Netzwerk an
              langjährigen und erfahrenen Kooperationspartnern zusammen.
            </p>
          </div>
        </div>

        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-526">
          <FlipCard frontTitle="Potenzialanalysen" backTitle="Potenziale auf den Punkt gebracht" link="/management-diagnostik/potenzialanalysen" data-id="element-527" />
          <FlipCard frontTitle="Assessment-Center" backTitle="Sichere Entscheidungen treffen für Schlüsselpositionen" link="/management-diagnostik/assessment-center" data-id="element-528" />
          <FlipCard frontTitle="Interviewtraining" backTitle="Fit für Gesprächsführung" link="/management-diagnostik/interviewtraining" data-id="element-529" />
        </div>
      </section>
    </>;
};